import { render } from "./ChartOfAccounts.vue?vue&type=template&id=3b752efb"
import script from "./ChartOfAccounts.vue?vue&type=script&lang=js"
export * from "./ChartOfAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Accounting/ChartOfAccounts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b752efb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b752efb', __exports__)) {
    api.reload('3b752efb', __exports__)
  }
  
  module.hot.accept("./ChartOfAccounts.vue?vue&type=template&id=3b752efb", () => {
    api.rerender('3b752efb', render)
  })

}


export default __exports__